module.exports = __webpack_public_path__ + "img/2bf952a0c1964fc9bbfc5551644b87c2.e0be6c38.jpg";